/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

const TitleContainer = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
`;

function VideoPlayerTitle({ assetDetails }) {
  return (
    <TitleContainer id="VideoPlayerTitle">
      {assetDetails?.title ? assetDetails.title : 'Source video preview'}
    </TitleContainer>
  );
}

VideoPlayerTitle.propTypes = {
  assetDetails: PropTypes.object, // supplied from Redux
};

const mapStateToProps = (state) => ({
  assetDetails: state.clipperMediaContent.assetDetails,
});

export default connect(
  mapStateToProps,
  null,
)(VideoPlayerTitle);
